import { render, staticRenderFns } from "./AMRelic80OG.vue?vue&type=template&id=52c84172&scoped=true"
import script from "./AMRelic80OG.vue?vue&type=script&lang=ts"
export * from "./AMRelic80OG.vue?vue&type=script&lang=ts"
import style0 from "./AMRelic80OG.vue?vue&type=style&index=0&id=52c84172&prod&lang=scss&scoped=true"
import style1 from "./AMRelic80OG.vue?vue&type=style&index=1&id=52c84172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c84172",
  null
  
)

export default component.exports